module.exports = __webpack_public_path__ + "static/media/Caleb_Harper_tablet.a385e582.jpg";